// Usage: In member list table
<template>
  <div
    v-click-outside="clickOutsideContextMenu"
  >
    <div
      class="button-role"
      :class="{
        'button-role-view-only': isButtonRoleViewOnly
      }"
      @click="clickMember"
    >
      <span> {{ getRole(member) }}</span>
      <aha-spinner
        v-if="isUpdatingRole"
        size="xs"
      />
      <aha-icon
        v-if="showDownArrowIcon"
        class="ml-auto mr-3.5"
        name="arrow"
        width="10"
        height="10"
        viewBox="0 0 24 24"
      />
    </div>
    <div
      v-show="showContextMenu"
      class="context-menu-role"
    >
      <ul>
        <li
          class="context-menu-item"
          @click="updateMemberRole(workspace.ADMIN)"
          v-show="showAdminOption"
        >
          <aha-icon
            :class="{'invisible': memberSelectedRole !== workspace.ADMIN}"
            name="check"
            class="text-primary-90"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Admin</span>
        </li>
        <li
          class="context-menu-item"
          @click="updateMemberRole(workspace.EDITOR)"
        >
          <aha-icon
            :class="{'invisible': memberSelectedRole !== workspace.EDITOR && memberSelectedRole !== workspace.VIEWER}"
            name="check"
            class="text-primary-90"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Member</span>
        </li>
        <!-- <li
          class="context-menu-item"
          @click="updateMemberRole(workspace.VIEWER)"
        >
          <aha-icon
            :class="{'invisible': memberSelectedRole !== workspace.VIEWER }"
            name="check"
            class="text-primary-90"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Viewer</span>
        </li> -->
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import constants from '@/constant'
import Util from '@/util'
import EventBus from '@/eventBus'

export default {
  props: {
    member: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      workspace: constants.workspace,
      showContextMenu: false,
      memberSelectedRole: '',
      isUpdatingRole: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    showDownArrowIcon() {
      if (this.isUpdatingRole) return false
      // Admin can not set role for another admin
      if (this.currentUser.accountRole === this.workspace.ADMIN
        && this.member.accountRole !== this.workspace.ADMIN) return true
      // Owner can set role for admin, editor, viewer
      return this.currentUser.accountRole === this.workspace.OWNER
    },
    showAdminOption() {
      return this.currentUser.accountRole === this.workspace.OWNER
    },
    isButtonRoleViewOnly() {
      if (this.currentUser.accountRole === this.workspace.OWNER) return false
      if (this.currentUser.accountRole === this.workspace.ADMIN
        && this.member.accountRole !== this.workspace.ADMIN) return false
      return true
    },
  },
  mounted() {
    this.memberSelectedRole = this.member.accountRole
    EventBus.$on('memberRoleUpdated', () => { this.isUpdatingRole = false })
  },
  destroyed() {
    EventBus.$off('memberRoleUpdated')
  },
  methods: {
    clickMember() {
      if (this.currentUser.accountRole === this.workspace.OWNER) {
        this.showContextMenu = !this.showContextMenu
      } else if (this.currentUser.accountRole === this.workspace.ADMIN
        && this.member.accountRole !== this.workspace.ADMIN
      ) {
        this.showContextMenu = !this.showContextMenu
      } else {
        // do nothing
      }
    },
    getRole() {
      if (this.member.accountRole === 'owner') return 'Owner'
      if (this.member.accountRole === 'admin') return 'Admin'
      if (this.member.accountRole === 'editor') return 'Member'
      return 'Member'
    },
    updateMemberRole(roleValue) {
      if (roleValue !== this.member.accountRole) {
        this.isUpdatingRole = true
        this.$emit('updateMemberRole', roleValue, this.member)
        this.memberSelectedRole = roleValue
        Util.trackGA4AndMixpanel('Select role', {
          eventAction: 'Team management > Member list > Update member\'s role',
          eventCategory: 'Team Members',
          eventLabel: this.member.email,
          plan: this.$store.state.currentUser.plan,
          role: roleValue,
        })
      }
      this.showContextMenu = false
    },
    clickOutsideContextMenu() {
      this.showContextMenu = false
    },
  },
}
</script>
<style scoped lang='scss'>
.button-role {
  @apply inline-flex py-1 pl-3 items-center text-sm  cursor-pointer;
  width: 6.25rem;
  &:hover {
    background: white;
    border-radius: 14px;
  }
  span {
    margin-right: 6px;
  }
  &.button-role-view-only {
    width: unset;
    &:hover {
      background: unset;
      cursor: default;
    }
  }
}
.context-menu-role {
  @apply flex absolute p-1 mt-2 flex-col items-start;
  border: 1px solid #EBEBEB;
  z-index: 9999;
  background: #FFFFFF;
  box-shadow: 3px 3px 5px rgba(211, 215, 225, 0.42);
  border-radius: 0.375rem;
}
</style>
